module.exports = __webpack_public_path__ + "img/teach2.45393877.jpg";